
import React from 'react'
import { ArrowForward } from "@mui/icons-material"

import "./customicons.css"

export const ArrowForwardIconLightBlue = ({onClick }) => {

  return (
   
    <div>
      <ArrowForward className = "arrowForwardIconLightBlue" onClick = {onClick}/>
    
    </div> 

  )
}
  




